export default __webpack_public_path__ + "static/media/ri1.10e55045.png";